import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import HeroVariations from "./pages/HeroVariations";
import HowItWorks from "./pages/HowItWorks";
import Services from "./pages/Services";
import Fit from "./pages/Fit";
import FAQ from "./pages/FAQ";
import BookCall from "./pages/BookCall";
import StartIncorporation from "./pages/StartIncorporation";
import Insights from "./pages/Insights";
import InsightsArticle from "./pages/InsightsArticle";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import UploadDocuments from "./pages/UploadDocuments";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/variations" element={<HeroVariations />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/services" element={<Services />} />
            <Route path="/fit" element={<Fit />} />
            <Route path="/pricing" element={<Navigate to="/services" replace />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/book-call" element={<BookCall />} />
            <Route path="/start" element={<StartIncorporation />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightsArticle />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/upload-documents" element={<UploadDocuments />} />
          </Routes>
          <Footer />
          <BackToTop />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
